import { Link } from "react-router-dom";

const AppFooter = ({ containerClassName = "max-w-7xl mx-auto px-6" }) => {
  return (
    <footer className="bg-[#212529] py-6 mt-auto">
      <div className={`${containerClassName} flex flex-col sm:flex-row items-center justify-between gap-3`}>
        <p className="text-sm text-gray-400">© 2024 smartdienstplan. Einfache Dienstplanung für Teams.</p>
        <div className="flex items-center gap-5 text-sm">
          <Link to="/datenschutz" className="text-gray-400 hover:text-white">
            Datenschutz
          </Link>
          <Link to="/impressum" className="text-gray-400 hover:text-white">
            Impressum
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default AppFooter;
